import { render, staticRenderFns } from "./VabSideBarItem.vue?vue&type=template&id=d335657a&scoped=true&"
import script from "./VabSideBarItem.vue?vue&type=script&lang=js&"
export * from "./VabSideBarItem.vue?vue&type=script&lang=js&"
import style0 from "./VabSideBarItem.vue?vue&type=style&index=0&id=d335657a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d335657a",
  null
  
)

export default component.exports